import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as r, Fragment as s, jsx as t } from "react/jsx-runtime";
import { concatClassNames as a } from "@sys42/utils";
import { ButtonPrimary as m } from "../ButtonPrimary/index.js";
import '../../assets/index21.css';
var u = "_buttonPrimaryLarge_una4d_1",
  d = {
    buttonPrimaryLarge: u
  };
function g(_ref) {
  var o = _ref.className,
    n = _ref.children,
    e = _objectWithoutProperties(_ref, _excluded);
  var i = /* @__PURE__ */r(s, {
    children: [/* @__PURE__ */r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      fill: "none",
      viewBox: "0 0 16 16",
      children: [/* @__PURE__ */t("path", {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M10.254 9.333l3.667-3.666L10.254 2"
      }), /* @__PURE__ */t("path", {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M3.333 14V8.333A2.667 2.667 0 016 5.667h7.667"
      })]
    }), n]
  });
  return m(_objectSpread({
    className: a(d.buttonPrimaryLarge, o),
    children: i
  }, e));
}
export { g as ButtonPrimaryLarge };